<nn-graph type='directed'></nn-graph>